import { render } from "./CustomerReviews.vue?vue&type=template&id=cc78d902&scoped=true"
import script from "./CustomerReviews.vue?vue&type=script&lang=js"
export * from "./CustomerReviews.vue?vue&type=script&lang=js"

import "./CustomerReviews.vue?vue&type=style&index=0&id=cc78d902&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc78d902"]])

export default __exports__